module.exports = __webpack_public_path__ + "img/default-product.25b48f5f.png";